<script>

  export default {
    name: 'Cover',
    props: {
      cover: {
        required: true,
      },
    },
  }
</script>

<template lang="pug">

div.cover-book(:class="{'animated-background': !cover}")
  img.img(v-if="cover", :src="cover")
</template>

<style lang="postcss" scoped>

  .cover-book{
    // background-color: grey;
    // width: 80px;
    // flex-shrink: 0;
    overflow: hidden;
    & .img {
      object-fit: contain;
      font-family: 'object-fit: contain;';
      width: 100%;
      height: 100%;
      max-height: 25vh;
      box-shadow: 0 0 10px rgba(0,0,0,.3);

    }
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0
    }
    100% {
      background-position: 468px 0
    }
  }

  .animated-background {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: #eeeeee;
    // background: -webkit-gradient(linear, left top, right top, color-stop(8%, #eeeeee), color-stop(18%, #dddddd), color-stop(33%, #eeeeee));
    // background: -webkit-linear-gradient(left, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    // height: 96px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// cover-book.vue?67e6e33d